<template>
    <div class="jump-cart">
        <van-nav-bar title="查看库存" left-arrow fixed class="jump-nav-bar" @click-left="back"/>
        <div class="jump-cart-body">
            <div class="jump-cart-body-hd"></div>
                <div class="line" v-if="list.length==0"><span>没有数据</span></div>
                <van-row class="jump-cart-item" type="flex" v-for="item in list">
                    <van-col span="24">
                        <p><span>商品名称：</span>{{data.goodsName}}</p>
                        <p><span>超市名称：</span>{{item.shop_name}}</p>
                        <p><span>库存数：</span>{{item.store}}</p>
                        <p><span>冻结库存：</span>{{item.store_freeze}}</p>
                    </van-col>
                </van-row>
        </div>
    </div>
</template>
<script>
    import {NavBar, Row, Col, List} from "vant";

    export default {
        name: "userhistory",
        components: {
            [NavBar.name]: NavBar,
            [Row.name]: Row,
            [Col.name]: Col,
            [List.name]: List,
        },
        data() {
            return {
                checkedAll: false,
                list: [],
                loading: false,
                finished: false,
                total: 0,
                page: 1,
                data:{}
            };
        }, mounted: function () {
            this.onLoadd()
        },
        methods: {
            back() {
                history.back();
            }, onLoadd() {
                let that = this
                // 异步更新数据
                that.$api.post(
                    that.jumuc.stock.milkshop_stock_view,
                    {
                        "goodsId": that.$route.query.goodsId,
                        "goodsCode": that.$route.query.goodsCode,
                        "unit_zhxs": that.$route.query.unit_zhxs
                    },
                    successRes => {
                        that.data=successRes.data
                        let orderlist = successRes.data.objs
                        for (let i = 0; i < orderlist.length; i++) {
                            that.list.push(orderlist[i]);
                        }
                        that.page = successRes.data.pageNum + 1
                        that.total = successRes.data.total
                        // 加载状态结束
                        that.loading = false;

                        // 数据全部加载完成
                        if (this.list.length >= that.total) {
                            that.finished = true;
                        }
                    }
                )

            }
        }
    };
</script>
<style lang="less">
    @bule-thame: #3c6eeb;

    body {
        background-color: #f7f7f7;
    }

    .jump-cart {


        .van-hairline--bottom::after {
            border-bottom-width: 0px;
        }
        &-body {
            padding: 20px 10px 0;
            position: relative;
            &-hd {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 80px;
                background-color: @bule-thame;
            }
        }
        &-item {
            background-color: #fff;
            margin-bottom: 15px;
            align-items: center;
            border-radius: 20px;
            padding: 15px;
            position: relative;
            .van-checkbox {
                height: 100%;
                line-height: 100%;
            }
            &-img {
                img {
                    width: 100%;
                }
            }

            h4 {
                font-size: 14px;
                padding: 10px 0;
            }
            &-warp {
                align-self: flex-start;
            }
            p {
                font-size: 14px;
                &.item-time {
                    color: @bule-thame;
                    font-size: 16px;
                    text-align: right;
                }
                &.item-price {
                    color: red;
                    font-size: 16px;
                    i {
                        font-size: 18px;
                        float: right;
                        color: #f5a623
                    }
                }
            }
        }
    }
     .line{
        height: 1px;
        border-top: 1px solid #ddd;
        text-align: center;
        margin-top:100px;
        span{
            position: relative;
            top: -10px;
            background:  #f7f7f7;
            padding: 0 20px;
        }
    }
</style>

